<div  class="pdf-viewer-dialog"
      [ngClass]="{'pdf-viewer-dialog--loading': !documentLoaded}">
  <div class="pdf-viewer-dialog__header">
    <div class="pdf-viewer-dialog__header__close-btn" (click)="close()" cdkFocusRegionstart>
      <span class="material-icons">close</span>
    </div>
  </div>

  <div *ngIf="!documentLoaded"
       class="pdf-viewer-dialog__state">
    <app-container-spinner></app-container-spinner>
    <div class="pdf-viewer-dialog__state__description">
      {{ 'PDF_VIEWER_DIALOG.loading' | translate }}
    </div>
  </div>

  <div *ngIf="isError"
       class="pdf-viewer-dialog__state">
    <img [src]="errorIcon" alt="">
    <div class="pdf-viewer-dialog__state__description">
      {{ 'PDF_VIEWER_DIALOG.error' | translate }}
    </div>
  </div>

<!--  <pdf-viewer *ngIf="!isError"-->
<!--              class="pdf-viewer-dialog__viewer"-->
<!--              [src]="data.pdfUrl"-->
<!--              [render-text]="true"-->
<!--              [original-size]="false"-->
<!--              (error)="onError($event)"-->
<!--              (on-progress)="onProgress($event)"-->
<!--              (after-load-complete)="onAfterLoadComplete($event)"-->
<!--  ></pdf-viewer>-->
</div>
